import { paramsToQuery } from '@/base/MaUtils'
import { cacheRequest, makeRequest } from '@/base/MaRequestPooler'

export function getAppList({ storeName, developer, countryCode }) {
  return makeRequest(`/app/by-developer-id/${storeName}?${paramsToQuery({ developer, countryCode })}`)
}

export function search(query = '') {
  return makeRequest(`/app/search-by-developer-name?${paramsToQuery({ query })}`)
}

/**
 * Returns publisher name given developer id.
 * @param developerId
 * @returns {Promise<any>}
 */
export function getPublisherNameById(developerId = '') {
  return cacheRequest(`/app/publisher?${paramsToQuery({ developerId })}`)
}
